import React from 'react';

import { useStorageBookingFunnelAssignment } from '@utils/hooks/storage_booking_funnel_test';

import { ChallengerSmartStorageCart } from './challenger_smart_storage_cart';
import { ClassicSmartStorageCart } from './classic_smart_storage_cart';

/**
 * Storage cart (`/book/storage/cart`).
 * Classic (control) vs challenger confirm UI follows the same Abeet assignment
 * as the product page.
 */
export const SmartStorageCart = () => {
  const { isChallenger, isReady } = useStorageBookingFunnelAssignment();

  if (!isReady) return null;

  return isChallenger ? (
    <ChallengerSmartStorageCart />
  ) : (
    <ClassicSmartStorageCart />
  );
};
